import React from 'react';

import Name from './Name';
import AddressDisplay from './AddressDisplay';

export default ({ location, includePhone }) => (
  <div>
    <Name>{location.name}</Name>
    {includePhone && <a href={`tel:${location.phone_number}`}>{location.phone_number}</a>}
    <AddressDisplay distance={location.distance} address={location.address} />
  </div>
);
